import { useEffect } from 'react';

// Close a floating UI (dropdown, popover) when the user clicks outside any of
// the passed refs. Skips the outside-click if the click was inside any ref.
export default function useClickOutside(refs, onOutside, active = true) {
    useEffect(() => {
        if (!active) return undefined;

        const handler = (e) => {
            const list = Array.isArray(refs) ? refs : [refs];
            for (const ref of list) {
                if (ref?.current && ref.current.contains(e.target)) return;
            }
            onOutside(e);
        };

        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, [refs, onOutside, active]);
}
